import { setAppLanguage } from "@/app/i18n/setLanguage";
import { getItemLocaleStorage } from "@/lib/utils";
import { localesAvailable } from "@/app/constants/locale";
import { ELocalStorageKeys } from "@/app/types/localStorage";
import { ELocale } from "@/app/types/locale";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/Select";

export function LanguageSelector() {
  const storedLanguage = getItemLocaleStorage(ELocalStorageKeys.LANGUAGE);

  const handleLanguageChange = (value: string) => {
    setAppLanguage(value as ELocale);
  };

  return (
    <Select onValueChange={handleLanguageChange}>
      <SelectTrigger className="w-40">
        <SelectValue
          placeholder={
            storedLanguage
              ? localesAvailable[storedLanguage as ELocale]
              : "Language"
          }
        />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectItem value={ELocale.EN}>
            {localesAvailable["en-US"]}
          </SelectItem>
          <SelectItem value={ELocale.ES}>
            {localesAvailable["es-ES"]}
          </SelectItem>
          <SelectItem value={ELocale.CA}>{localesAvailable["ca"]}</SelectItem>
          <SelectItem value={ELocale.SV}>
            {localesAvailable["sv-SE"]}
          </SelectItem>
          <SelectItem value={ELocale.SW}>{localesAvailable["sw"]}</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
